import { Alert } from '@mui/material';

export const ApplicationApprovalErrorMessages = ({
  errorMessages,
}: {
  errorMessages: string[];
}) => {
  return (
    <Alert sx={{ my: 1 }} severity='error'>
      <span>One or more errors have occurred:</span>
      <ul>
        {errorMessages.map((errorMessage: string) => (
          <li key={`ErrorMessage: ${errorMessage.substring(0, 10)}`}>{errorMessage}</li>
        ))}
      </ul>
    </Alert>
  );
};
